<template>
    <div class="container-fluid" style="margin-top: 5%;">
        <v-row justify="center">
            <v-col class="py-0">
                <v-row class="py-0">
                    <v-col class="pl-3">
                        <v-row v-if="!isError && registrations == null" >
                            <v-col class="py-0" style="line-height: 20px; padding: 0% 5% 0% 5%;">
                                <p class="text-center red--text font-weight-bold">{{$t("unPaidRegistration.completeRegistration.text4")}}</p>
                                <a class="text-center" style=" width: 100%; display: block;">{{$t("unPaidRegistration.completeRegistration.back_registration")}}</a>
                            </v-col>
                        </v-row>
                        <v-row v-if="!isError && registrations">
                            <v-col class="py-0" style="line-height: 20px; padding: 0% 5% 0% 5%;">
                                <p class="text-center text-h5">
                                   <i class="far fa-check-circle fa-2x"></i>
                                    {{$t("unPaidRegistration.completeRegistration.title")}} 
                                </p>
                                <p class="text-center">
                                    <i class="far fa-calendar"></i>
                                    {{$t("unPaidRegistration.completeRegistration.text1")}} <span class="text-caption">{{$t("unPaidRegistration.completeRegistration.text2")}}</span>                                
                                </p>
                                <v-row>
                                    <v-col cols="6" style="margin: 0 auto;">
                                        <v-card outlined class="pa-4" style="text-align: center;"><!--January 1st, 2021 to December 31st, 2021--></v-card>
                                    </v-col>
                                </v-row>  
                                <br />
                                <p class="text-center">
                                    {{$t("unPaidRegistration.completeRegistration.text3")}}
                                </p>
                            </v-col>
                        </v-row>
                        <div v-if="!isError && registrations">
                            <v-row v-for="(r,i) in registrations" :key="i">
                                <v-col cols="5" style="margin: 0 auto; max-width: 500px;">
                                    <h3 style="text-align: center;">{{r.user[0].firstName}} {{r.user[0].lastName}}</h3>
                                    <v-card-text class="bcard">
                                        <v-row style="padding-top: 20px;">
                                            <v-col md="12" class="text-left" id="printMe1">
                                                <v-row class="bg_row">
                                                    <v-col md="3">
                                                        <p>{{ $t("viewRegistration.event") }}: </p>
                                                        <p>{{ $t("viewRegistration.promoter") }}: </p>
                                                        <p>{{ $t("viewRegistration.name") }}: </p>
                                                        <p>{{ $t("viewRegistration.class") }}: </p>
                                                        <p>{{ $t("viewRegistration.number") }}: </p>
                                                        <p>{{ $t("viewRegistration.token") }}: </p>
                                                    </v-col>
                                                    <v-col md="9">
                                                        <p>{{event.eventName}}</p>
                                                        <p>{{promoterName ? promoterName : '---'}}</p>
                                                        <p>{{r.user[0].firstName}} {{r.user[0].lastName}}</p>
                                                        <p>{{r.registration.className}}</p>
                                                        <p>{{r.registration.number ? r.registration.number : '---'}}</p>
                                                        <p>{{r.registration.token}}</p>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-col>
                            </v-row>
                        </div>
                        <v-row v-if="!isError && registrations">
                            <v-col class="py-0" style="line-height: 20px; padding: 0% 5% 0% 5%;">
                                <v-row>
                                    <v-col cols="4" style="margin: 0 1rem 0 auto;">
                                        <v-card outlined class="pa-4" style="text-align: center;">
                                            <strong>{{$t("unPaidRegistration.completeRegistration.id-paypal")}}</strong> <br />
                                            {{token}}
                                        </v-card>
                                    </v-col>
                                    <v-col cols="4" style="margin: 0 auto 0 1rem;">
                                        <v-card outlined class="pa-4" style="text-align: center;">
                                            <strong>{{$t("unPaidRegistration.completeRegistration.total-paid")}}</strong> <br />
                                            $1.00
                                        </v-card>
                                    </v-col>
                                </v-row> 
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import RegistrationService from '@/services/RegistrationService';
import {VRow, VCol, VCardText, VCard } from 'vuetify/lib';
import LocalStorageService from '../services/LocalStorageService';
export default {
    components:{
       VRow, VCol, VCardText , VCard
    },
    data() {
        return {
            event: null,
            userId: null,
            token: null,
            response: null,
            isError: false,
            registrations: false,
            promoterName: null
        };
    },
    methods: {
        async getRegistrant() {
            this.response = await RegistrationService.getCompleteRegistration({eventId: this.eventId, userId: this.userId, token: this.token});
            if(this.response && this.response.data && this.response.data.success) {
                this.isError = this.response.data.message.isError;
                this.registrations = this.response.data.message.registrations;
                this.event = this.response.data.message.event;
                this.promoterName = this.response.data.message.promoterName;
                this.cleanLocalStorage();
            } else {
                this.isError = false;
                this.registrations = null;
                this.event = null;
                this.promoterName = null;
            }
        },
        cleanLocalStorage() {
            LocalStorageService.removeItem("registrationType");
            LocalStorageService.removeItem("summary");
            LocalStorageService.removeItem("regId");
            LocalStorageService.removeItem("registration");
            LocalStorageService.removeItem("organizations");
        }
    },
    created() {
        this.eventId = this.$route.query.eId;
        this.userId = this.$route.query.uId;
        this.token = this.$route.query.token;
        this.getRegistrant();
    }    
}
</script>

<style scoped>
.bg_row {
    background-image: url(/participant/img/BackGroundImage.c515e0cf.png);
    background-size: contain !important;
    background-repeat: no-repeat !important;
    padding-top: 70px;
    padding-bottom: 70px;
}
.bg_row p {
    margin-bottom: 10px;
}
</style>